module.exports = __webpack_public_path__ + "static/img/2_2_1.022f8e3d.jpg";